module.exports = __webpack_public_path__ + "static/media/icon_3.3e7a8871.svg";